import { IOption } from '../../../common/common.types'

export interface IFillablePDF {
  id: string
  name: string
  author: IOption | null
  customInputs: ICustomInputs
  showModal: boolean
  pdfDocId: string
  pdfUrl: string
  pdfLoading: boolean
  pdfError: string
}

export interface IFillablePDFsState extends IFillablePDF {
  __currentStep: number
  __deleteFillablePDFId?: string
  fillablePDFsList: IPDFList
}

export interface IPDFListItem {
  id: string
  name: string
}

export type IPDFList = Array<IPDFListItem>

export interface ICustomInput {
  question: string
  answerId: any
  questionId: string
  fieldType: string
  isDisabled?: boolean
}

export type ICustomInputs = Array<ICustomInput>

export const inputTypeLookup: Record<string, string> = {
  StringInput: 'text',
  SingleSelect: 'choice',
  MultiSelect: 'listbox',
  Toggle: 'checkbox',
}

export type ElementType = 'input' | 'radio' | 'checkbox' | 'date' | 'textarea' | 'signature'

export interface IFillablePDFsAction extends IFillablePDFsState {
  fillablePDFsState: IFillablePDFsState
  type: string
}
